<div [formGroup]="form">
  <div class="row">
    <div class="col-12 col-md-4">
      <label for="asOfDate">Report Annualized Earnings and Rates as of:</label>
    </div>
    <div class="col-12 col-md-2">
      <div class="input-group">
        <input
          id="asOfDate"
          type="text"
          class="form-control datepicker"
          formControlName="asOfDate"
          ngbDatepicker
          #s="ngbDatepicker"
          [firstDayOfWeek]="7" />
        <img src="assets/icons/calendar.svg" (click)="s.toggle()" class="icon-append" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        label="Include Pickup/Successor Figures"
        formControlName="includePickupFigures"></lib-checkbox>
    </div>
  </div>

  <lib-report-buttons
    [formats]="buttons"
    [disabled]="form.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
